<template>
  <div class="page">
    <div class="main-area">
      <h3 style="margin: 0 0 20px 0">内置角色</h3>
      <el-table :data="tableData" border>
        <el-table-column width="200px" prop="name" label="角色名称">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="角色描述"></el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>

export default {
  name: 'ManagerRoleViewPage',
  components: {},
  data() {
    return {
      tableData: [
        {name: "超级管理员", code: "ADMIN", description: "默认超级管理员，拥有全部权限，账号唯一不可分配"},
        {name: "系统管理员", code: "MANAGE", description: "拥有除了创建系统账号外，所有页面的权限"},
        {name: "系统查看员", code: "VIEW", description: "拥有除了创建系统账号外，所有页面查看权限"},
        {name: "门岗助手", code: "GUARD", description: "签到签离权限"},
        // {name: "员工邀约", code: "STAFF", description: "普通员工权限"},
        {name: "首页大屏", code: "HOME", description: "首页大屏权限"},
      ]
    };
  },
  methods: {}
}
</script>

<style lang="less" scoped>
</style>
